module.exports = __webpack_public_path__ + "static/media/Profact-Admin-Walkthrough.ee95fb57.pdf";